export default "__VITE_ASSET__RferQ4vV__"